// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","caja":"Banner_caja__dfowe","containText":"Banner_containText__O+hID","botones":"Banner_botones__yXgMd"};